import React, { Component } from 'react';

class Configuracoes extends Component {
  render() {
    return (
      <div>
        <h1 data-testid="settings-title">Configurações</h1>
      </div>
    );
  }
}

export default Configuracoes;
